export default "__VITE_ASSET__3fd20181__"